import Img from '@/components/base/Img';
import SectionLabel from '@/components/feature/SectionLabel';
import { processImage } from '@/mocks/site';

const stages = [
  { n: '01', title: 'Surface Assessment', text: 'We inspect the walls on site, identify the substrate and the causes of damage, and agree the scope with you before anything is quoted.' },
  { n: '02', title: 'Finish & Colour Direction', text: 'Material and tone are chosen for the wall, then confirmed on sample panels in real daylight on the elevation itself.' },
  { n: '03', title: 'Restoration & Application', text: 'Repairs are completed and allowed to cure. Finishes are then applied by hand, coat by coat, at the pace the material needs.' },
];

export default function Process() {
  return (
    <section className="py-20 md:py-28">
      <div className="shell grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-12 items-start">
        <figure className="lg:col-span-6">
          <div data-reveal="image" className="overflow-hidden"><Img src={processImage} alt="Plasterer applying lime render to an exterior wall with a steel trowel" className="w-full aspect-[4/5]" /></div>
          <figcaption className="meta mt-3">Lime render, second coat, applied by hand</figcaption>
        </figure>
        <div className="lg:col-span-5 lg:col-start-8 lg:sticky lg:top-20 flex flex-col">
          <SectionLabel index="05">Our Process</SectionLabel>
          <h2 data-reveal="title" className="h-section mt-6">Craft, in three stages</h2>
          <ol className="mt-10 md:mt-14 border-t border-foreground-950">
            {stages.map((s) => (
              <li key={s.n} className="grid grid-cols-[3rem_1fr] gap-3 py-6 md:py-7 border-b border-background-300">
                <span className="meta text-accent-600 pt-1">{s.n}</span>
                <div>
                  <h3 className="font-heading font-medium text-lg">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{s.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}